import actionTypes from './actionTypes';

const requestStatsConfig = (args) => ({
    type: actionTypes.REQUEST_STATS_CONFIG,
    payload: args,
});

const statsConfigResponse = (success, errors, config) => ({
    type: actionTypes.STATS_CONFIG_RESPONSE,
    payload: {
        success,
        errors,
        config,
    },
});

export default {
    requestStatsConfig,
    statsConfigResponse,
};
